<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/OurTXX/tc-custom/9780830878185.jpg?1696025334042" alt="This image is the cover for the book A Better Freedom"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Better Freedom
      </h1>
      <p class="bookDescription body article font2">
        <p>When Michael Card first started attending an African American church, he was struck by how the congregation worshiped Jesus as "Master." He soon learned that during slavery, calling Jesus "Master" was a subtle way of saying that their earthly masters were not their true Master. This insight led Card on a journey of discovery, as he wondered, "What did it mean for African American slaves to acknowledge Jesus as Master? What did Paul, Peter, Jude and James mean when they acknowledged themselves as Christ's slaves? What would it mean for you and me to take upon ourselves the title 'slave of Christ'?" <em>A Better Freedom</em> explores the biblical imagery of slavery as a metaphor for Christian discipleship. Michael Card shows how the early church saw Greco-Roman slavery as a window into understanding Jesus both as the Savior who took on the form of a slave, but also the true Lord and Master who sets us free from our own slavery to sin. Come, let yourself be captured by the Master. And discover how you can be truly set free.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Card
      </h2>
      
      <p class="authorDescription body article"><p>In a career that spans 30 years, Michael Card has recorded over 31 albums, authored or co-authored over 24 books, hosted a radio program, and written for a wide range of magazines. An award-winning musician and performing artist, he has penned such favorites as "El Shaddai," "Immanuel" and many other songs. He has branched his ministry beyond music and written numerous books, including <em>A Sacred Sorrow, A Violent Grace, The Parable of Joy</em> and <em>Sleep Sound in Jesus</em> (a children's book). He has also written the <em>Biblical Imagination Series,</em> with a book and accompanying music CD for each of the four gospels. A graduate of Western Kentucky University with a bachelor's and master's degree in biblical studies, Card also serves as mentor to many younger artists and musicians, teaching courses on the creative process and calling the Christian recording industry into deeper discipleship. Card lives in Tennessee with his wife and four children.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bd1d3bb2